/* eslint class-methods-use-this: 0 */
import { t } from 'i18next';
import React from 'react';
import {
  Modal,
  Button,
  Row,
  Col,
  DropdownButton,
  MenuItem,
} from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import _ from 'underscore';
import { titleize } from 'underscore.string';

import {
  isDrayageShipment,
  isRailShipment,
  isImport,
  isDomesticDelivery,
} from '../../../helpers/shipment-types.js';

const ShorthaulChoices = {
  in_progress: 'IN_PROGRESS',
  scheduled: 'SCHEDULED',
  exposed: 'EXPOSED',
};

const IncomingDrayageChoices = {
  en_route: 'EN_ROUTE',
  in_progress: 'IN_PROGRESS',
};

const RailAndOtherDrayageChoices = {
  in_progress: 'IN_PROGRESS',
};

class ShipmentReopenModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getValidationState() {
    return 'success';
  }

  handleReopen(choices) {
    const node = this.state.node;
    const meta = {
      timestamp: new Date(),
      reason: choices[node],
      reopen_shipment: true,
    };

    switch (node) {
      case 'en_route':
      case 'scheduled':
      case 'exposed':
      case 'in_progress':
        this.props.transition(this.props.shipment, node, meta);
        break;
      default:
        console.log(`No transition for state ${node}`);
    }

    this.props.onHide();
  }

  getReopenChoices(shipment) {
    let choices = ShorthaulChoices;
    if (isRailShipment(shipment)) {
      choices = RailAndOtherDrayageChoices;
    } else if (isDrayageShipment(shipment)) {
      if (isImport(shipment) || isDomesticDelivery(shipment)) {
        choices = IncomingDrayageChoices;
      } else {
        choices = RailAndOtherDrayageChoices;
      }
    }
    return choices;
  }

  render() {
    const shipment = this.props.shipment;
    if (!shipment) return null;
    const { t } = this.props;
    const choices = this.getReopenChoices(shipment);

    return (
      <Modal show={this.props.show} onHide={() => this.props.onHide()}>
        <Modal.Header closeButton>
          <Modal.Title>
            {t('REOPEN_SHIPMENT_ID', { shipmentId: shipment.shipment_id })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row style={{ marginBottom: 10 }}>
            <Col xs={12}>{t('SPECIFY_REOPEN_MESSAGE')}</Col>
          </Row>
          <Row>
            <Col xs={12}>
              <DropdownButton
                title={t(choices[this.state.node]) || t('NEW_STATE')}
                onSelect={(key) => this.setState({ node: key })}
                id="shipment-reopen-choices"
              >
                {_.map(choices, (value, key) => {
                  return (
                    <MenuItem key={key} eventKey={key}>
                      {t(value)}
                    </MenuItem>
                  );
                })}
              </DropdownButton>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={8} />
            <Col xs={4}>
              <Button
                onClick={() => this.props.onHide()}
                style={{ marginRight: 5 }}
                bsStyle="danger"
              >
                {titleize(t('CANCEL'))}
              </Button>
              <Button
                disabled={this.getValidationState() !== 'success'}
                bsStyle="success"
                onClick={() => this.handleReopen(choices)}
              >
                {t('OPEN')}
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default withTranslation()(ShipmentReopenModal);
